import { FC } from 'react'
import { useQuery } from 'react-query'
import { fetchPostById, addPV } from 'src/services'
import Loading from 'src/components/Loading/Loading'
import Layout from 'src/containers/Layout/Layout'
import PostContainer from 'src/containers/Post/PostDetail'

const PostPage: FC = () => {
  const { data: post, isFetching, isLoading } = useQuery('post', () =>
    fetchPostById(window.location.pathname.replace('/post/', '')),
  )

  useQuery('pv', () => addPV(window.location.pathname.replace('/post/', '')))

  if (isFetching || isLoading || !post) return <Loading />

  return (
    <Layout>
      <PostContainer post={post} />
    </Layout>
  )
}

export default PostPage
